import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_DELETE_KEYWORD } from 'constants/urls';

/**
 * Removes a keyword by ID.
 * @param id - The ID of the keyword to remove
 * @returns The API response data
 * @throws Re-throws any Axios error after logging
 */
const removeKeyword = async (id: number) => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: URL_CANTRACK_DELETE_KEYWORD,
      data: { id },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[removeKeyword] Failed:', error);
    throw error;
  }
};

export default removeKeyword;
